import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const VehicleCard = ({
  productName,
  onManageClick,
  registrationNr,
  vin_nr,
  licenceNr,
  engineNr,
  make,
  series,
  notList,
  image,
  selector,
  onSelectClcik,
}) => {
  const [hover, setHover] = useState(false);
  //   register_nr  (7)

  // licence_nr (9)

  // vin_nr (17)

  // engine_nr (20)

  // make (50) this is a look up of the make table

  // series (100) this is a look up of the series table of series with the make from above.
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: "90%",
        width: "80%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
      }}
    >
      <div style={{ flex: 0.1 }}></div>
      <div
        onClick={selector ? onSelectClcik : null}
        style={{
          flex: 0.9,
          backgroundColor: hover ? colors.greenLight : null,
          borderRadius: 10,
          //WebkitBoxShadow: hover ? "-5px 5px 15px -1px #00000070" : null,
          transition: "all 0.7s",
          position: "relative",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
          borderStyle: "solid",
          borderWidth: notList ? 3 : 0,
          borderColor: colors.greenLight,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: hover ? -70 : -60,
            transition: "all 0.5s",
            left: -10,
          }}
        >
          <img
            alt="icon"
            src={
              image
                ? image
                : require("../../../../../../images/generic-placeholders/genericvehicle.png")
            }
            style={{ width: 160, zIndex: 300 }}
          />
        </div>
        <div style={{ width: "100%", marginRight: 10 }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 16 : 12,
                fontWeight: "bolder",
                marginTop: 50,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>REGISTER NR</div>
              {registrationNr}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>LICENCE NR</div>
              {licenceNr}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>VIN NR</div>
              {vin_nr}
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                // marginTop: 5,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                marginTop: -15,
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>ENGINE NR</div>
              {engineNr}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>MAKE</div>
              {make}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                color: hover ? colors.white : colors.secondaryDarkBlue,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>SERIES</div>
              {series}
            </div>
          </div>
        </div>
        {notList ? null : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
              position: "absolute",
              bottom: hover ? -25 : -20,
              transition: "all 0.25s",
            }}
          >
            <BaseButtons
              label={"MANAGE"}
              color={hover ? colors.secondaryDarkBlue : colors.white}
              backgroundColor={hover ? colors.white : colors.greenDark}
              borderRadius={8}
              width={"80%"}
              onClick={onManageClick ? onManageClick : null}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleCard;
